<template functional>
  <el-container direction="vertical">
    <div>{{ props.customer.name }}</div>
    <template v-for="amocrm in props.customer.amocrm">
      <div
        :key="amocrm.uuid"
        style="margin: 10px 10px 0 0; display: flex; align-items: center; border: 1px inset; border-radius: 5px"
      >
        <div style="margin-left: 5px">
          <amo-crm_logo :size="16" />
        </div>
        <div style="margin-left: 5px; padding: 5px; border-left: 1px inset">
          <div>{{ amocrm.domain }}</div>
          <div>{{ amocrm.login }}</div>
          <div>{{ amocrm.secret_key }}</div>
          <div>{{ amocrm.account_id }}</div>
        </div>
      </div>
    </template>
    <template v-for="contact in props.customer.contacts">
      <div
        :key="contact.uuid"
        style="margin: 10px 10px 0 0; display: flex; align-items: center; border: 1px inset; border-radius: 5px"
      >
        <div style="margin-left: 5px">
          <i
            class="el-icon-user-solid"
            style="width: 64px;text-align: center"
          ></i>
        </div>
        <div style="margin-left: 5px; padding: 5px; border-left: 1px inset">
          <div>{{ contact.name }}</div>
          <div>{{ contact.email }}</div>
          <div>{{ contact.phone }}</div>
        </div>
      </div>
    </template>
  </el-container>
</template>

<script>
export default {
  name: "customer"
};
</script>

<style scoped></style>
